import store from '../store';
import { getSellerServices as _getSellerServices } from '../../services/Services';

import {
  SET_ACTIVE_SUBSCRIPTION_COUNT,
  SET_IN_ACTIVE_SUBSCRIPTION_COUNT,
  SET_PROFILE_COMPLETED,
  SET_SELLER_SERVICES,
  SET_DISABLE_SELLER_REDIRECTION,
  SET_TOS_SIGNED
} from '../constants/AppConstants';


const setSellerServices = (services) => {
  return {
    type: SET_SELLER_SERVICES,
    payload: services
  }
}

export const refreshSellerServices = () => {
  return async dispatch => {
    try {
      const response = await _getSellerServices();
      if (response.resStatus == 200) {
        const services = response.data;
        dispatch(setSellerServices(services));
      }
    } catch (error) {
      console.log(error);
    }
  }
};


export const setSellerProfileCompleted = (profileCompleted) => {
  return {
    type: SET_PROFILE_COMPLETED,
    payload: profileCompleted
  }
}

export const setActiveSubscriptionCount = (count) => {
  return {
    type: SET_ACTIVE_SUBSCRIPTION_COUNT,
    payload: count
  }
}

export const setInActiveSubscriptionCount = (count) => {
  return {
    type: SET_IN_ACTIVE_SUBSCRIPTION_COUNT,
    payload: count
  }
}

export const setDisableSellerRedirection = (disableRedirection) => {
  return {
    type: SET_DISABLE_SELLER_REDIRECTION,
    payload: disableRedirection
  }
}

export const setTOSSigned = (tosSigned) => {
  return {
    type: SET_TOS_SIGNED,
    payload: tosSigned
  }
}